import Vue from 'vue';
import {
  Pagination,
  Dialog,
  Select,
  Option,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  MessageBox,
  Message,
  Notification
} from 'element-ui';

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;



// WEBPACK FOOTER //
// ./src/ui.js